import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const loc = localStorage.getItem("pb_location");
  if (loc) config.headers["X-Location-Id"] = loc;
  return config;
});

export function apiErr(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || fallback;
}

// Opens a protected file (PDF report / image) by fetching it WITH the auth header
// as a blob, then showing that blob. Avoids putting the token in the URL and
// avoids navigating the app to a protected server URL (which could render a raw
// "Not authenticated" page and break back-navigation on mobile).
export async function openAuthedFile(relUrl, { onError } = {}) {
  const win = window.open("", "_blank"); // open synchronously to survive popup blockers
  try {
    const res = await api.get(relUrl, { responseType: "blob" });
    const blobUrl = URL.createObjectURL(res.data);
    if (win) {
      win.location.href = blobUrl;
      // Revoke only once the viewer tab is closed, so long viewing sessions don't break.
      const timer = setInterval(() => {
        if (win.closed) { clearInterval(timer); URL.revokeObjectURL(blobUrl); }
      }, 5000);
    } else {
      window.open(blobUrl, "_blank");
    }
  } catch (e) {
    if (win) win.close();
    if (onError) onError(e); else throw e;
  }
}
